import { Button, Card, Icons, Stack, Typography } from '@healthinal/ui';
import { useNavigate } from '@tanstack/react-router';
import { HistoryDto, PatientBasicsDto } from '../../../api/generated/model';
import { SubCard } from '../../../components/SubCard.tsx';
import { PatientAddressDisplay } from '../../components/patient-address/PatientAddressDisplay.tsx';
import { HistoryEntry } from './HistoryEntry.tsx';

export function HistoryDirectlyObservedTherapyStarted({
  history,
  patient,
}: {
  history: HistoryDto;
  patient: PatientBasicsDto;
}) {
  const navigate = useNavigate();
  return (
    <HistoryEntry history={history} subject={'Eine DOT wurde bei'} action={'gestartet von'} patient={patient}>
      {history.directlyObservedTherapy && (
        <Card>
          <Stack direction={'row'} justifyContent={'space-between'}>
            <Stack direction={'row'} gap={5}>
              <Stack gap={1}>
                <Typography level={'title-md'}>Auftraggeber</Typography>
                <SubCard>
                  <PatientAddressDisplay flex={3} patientAddress={history.directlyObservedTherapy.applicant} />
                </SubCard>
              </Stack>
              <Stack gap={1}>
                <Typography level={'title-md'}>Durchführer</Typography>
                <SubCard>
                  <PatientAddressDisplay flex={3} patientAddress={history.directlyObservedTherapy.executor} />
                </SubCard>
              </Stack>
            </Stack>
            <Stack alignItems={'start'}>
              <Button
                endDecorator={<Icons.ArrowForward />}
                onClick={() =>
                  navigate({ to: '/patients/$patientId/therapy', params: { patientId: history.patientId } })
                }>
                Zur Therapie
              </Button>
            </Stack>
          </Stack>
        </Card>
      )}
    </HistoryEntry>
  );
}
